"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValues = exports.getParams = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _existingPawn3 = _interopRequireDefault(require("./existingPawn.graphql"));
var _form = _interopRequireDefault(require("./form.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Appdefs = window.cccisd.appDefs;
var Boilerplate = window.cccisd.boilerplate;
var existingUserMsg = 'The specified username belongs to an active user.';
var getParams = exports.getParams = function getParams(values) {
  var firstName = values.firstName,
    lastName = values.lastName,
    username = values.username,
    role = values.role,
    group = values.group,
    email = values.email,
    passcode = values.passcode,
    phone = values.phone,
    field1 = values.field1,
    field2 = values.field2,
    field3 = values.field3,
    field4 = values.field4,
    field5 = values.field5,
    pawnHash = values.pawnHash;
  return {
    first_name: firstName,
    last_name: lastName,
    username: username,
    user: values.user,
    role: role,
    group: group,
    field_1: field1,
    field_2: field2,
    field_3: field3,
    field_4: field4,
    field_5: field5,
    activate: false,
    email: email,
    passcode: passcode,
    phone: phone,
    pawnHash: pawnHash
  };
};
var getValues = exports.getValues = function getValues(row) {
  return {
    firstName: row['pawn.user.firstName'],
    lastName: row['pawn.user.lastName'],
    username: row['pawn.user.username'],
    field1: row['pawn.fields.field_1'],
    field2: row['pawn.fields.field_2'],
    field3: row['pawn.fields.field_3'],
    field4: row['pawn.fields.field_4'],
    field5: row['pawn.fields.field_5'],
    email: row['pawn.user.email'],
    passcode: row.passcode,
    phone: row['pawn.user.phone'],
    user: row['pawn.user.userId']
  };
};
var RespondentForm = /*#__PURE__*/function (_React$Component) {
  function RespondentForm(props) {
    var _this;
    _classCallCheck(this, RespondentForm);
    _this = _callSuper(this, RespondentForm, [props]);
    _defineProperty(_this, "getErrorsFromAjax", function (response) {
      var _response$data, _data;
      var isSuppressExisting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!(response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.errors) && response.status === 200) {
        return;
      }
      var errs = response.data.errors;
      var data = {
        username: 'Error saving respondent'
      };
      if (_typeof(errs) === 'object' && !Array.isArray(errs) && Array.isArray(Object.values(errs)[0])) {
        data = Object.keys(errs).reduce(function (prev, curr) {
          var errMsg = Array.isArray(errs[curr]) ? errs[curr][0] : errs[curr];
          return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, curr, errMsg));
        }, {});
      }
      if (isSuppressExisting && ((_data = data) === null || _data === void 0 ? void 0 : _data.username) === existingUserMsg) {
        delete data.username;
      }
      if (Object.keys(data).length === 0) {
        return;
      }
      (0, _cccisdNotification["default"])({
        duration: 0,
        message: 'Error',
        type: 'danger',
        data: data
      });
      return data;
    });
    _defineProperty(_this, "onSubmit", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(values) {
        var _existingPawn, _existingPawn$pawn, _pawnResponse$data, _pawnResponse$data$da, _existingPawn2, _existingPawn2$pawn;
        var _this$props, closeModal, deploymentId, loadData, projectId, pawnResponse, isExistingUser, existingPawn, isAlreadyInDeployment, existingPawnResponse, pawnErrors, confirmResponse, attempts, pawnId, respondentResponse, respondentErrors;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this$props = _this.props, closeModal = _this$props.closeModal, deploymentId = _this$props.forCycle.deploymentId, loadData = _this$props.loadData, projectId = _this$props.projectId;
              _context.n = 1;
              return _cccisdAxios["default"].post(Boilerplate.route('api.nexus.pawn.store'), getParams(values));
            case 1:
              pawnResponse = _context.v;
              isExistingUser = (0, _get2["default"])(pawnResponse, 'data.errors.username[0]', false) === existingUserMsg;
              if (!isExistingUser) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return _cccisdApollo.client.query({
                query: _existingPawn3["default"],
                variables: {
                  username: values === null || values === void 0 ? void 0 : values.username,
                  questProjectId: projectId,
                  deploymentId: deploymentId
                },
                fetchPolicy: 'network-only'
              });
            case 2:
              existingPawnResponse = _context.v;
              existingPawn = (0, _get2["default"])(existingPawnResponse, 'data.roles.respondent', null);
              isAlreadyInDeployment = (0, _get2["default"])(existingPawnResponse, 'data.flows.respondent.respondentId', null);
            case 3:
              if (!isAlreadyInDeployment) {
                _context.n = 4;
                break;
              }
              return _context.a(2, Promise.reject({
                username: 'This user is already a respondent for this data collection wave.'
              }));
            case 4:
              if (!(isExistingUser && !((_existingPawn = existingPawn) !== null && _existingPawn !== void 0 && (_existingPawn$pawn = _existingPawn.pawn) !== null && _existingPawn$pawn !== void 0 && _existingPawn$pawn.pawnId))) {
                _context.n = 5;
                break;
              }
              return _context.a(2, Promise.reject({
                username: 'This username belongs to an existing user, and it cannot be used here. ' + 'Either the existing user is in a different Quest Project, ' + 'or they have a role other than `Respondent`'
              }));
            case 5:
              pawnErrors = _this.getErrorsFromAjax(pawnResponse, isExistingUser);
              if (!pawnErrors) {
                _context.n = 6;
                break;
              }
              return _context.a(2, Promise.reject(pawnErrors));
            case 6:
              if (!existingPawn) {
                _context.n = 10;
                break;
              }
              confirmResponse = null;
              _this.setState({
                existingPawn: existingPawn,
                isConfirmedExisting: null
              });
              _this.confirmModal.current.open();
              attempts = 0;
            case 7:
              if (!(confirmResponse === null && attempts < 3000)) {
                _context.n = 9;
                break;
              }
              _context.n = 8;
              return new Promise(function (res) {
                return setTimeout(res, 300);
              });
            case 8:
              confirmResponse = _this.state.isConfirmedExisting;
              attempts++;
              _context.n = 7;
              break;
            case 9:
              if (confirmResponse) {
                _context.n = 10;
                break;
              }
              _this.setState({
                existingPawn: null,
                isConfirmedExisting: null
              });
              return _context.a(2);
            case 10:
              pawnId = (pawnResponse === null || pawnResponse === void 0 ? void 0 : (_pawnResponse$data = pawnResponse.data) === null || _pawnResponse$data === void 0 ? void 0 : (_pawnResponse$data$da = _pawnResponse$data.data) === null || _pawnResponse$data$da === void 0 ? void 0 : _pawnResponse$data$da.id) || ((_existingPawn2 = existingPawn) === null || _existingPawn2 === void 0 ? void 0 : (_existingPawn2$pawn = _existingPawn2.pawn) === null || _existingPawn2$pawn === void 0 ? void 0 : _existingPawn2$pawn.pawnId); // `pawnIds` as an array and `pawnIdPasscodeMap` are a little weird,
              // but we need them like that to maintain backwards compatibility with api
              _context.n = 11;
              return _cccisdAxios["default"].post(Boilerplate.route('api.assignmentDeploymentRespondent.store', {
                deploymentId: deploymentId
              }), {
                pawnIds: [pawnId],
                pawnIdPasscodeMap: _defineProperty({}, pawnId, values.passcode)
              });
            case 11:
              respondentResponse = _context.v;
              respondentErrors = _this.getErrorsFromAjax(respondentResponse);
              if (!respondentErrors) {
                _context.n = 12;
                break;
              }
              return _context.a(2, Promise.reject(respondentErrors));
            case 12:
              loadData();
              closeModal();
            case 13:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "renderConfirmModal", function () {
      var _this$state = _this.state,
        existingPawn = _this$state.existingPawn,
        isConfirmedExisting = _this$state.isConfirmedExisting;
      var importantFields = Appdefs.pawn.roles.find(function (r) {
        return r.handle === 'respondent';
      }).importantFields;
      return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        ref: _this.confirmModal,
        title: "Use existing user info?",
        afterClose: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                // cleanup of they closed using X button in top corner
                if (isConfirmedExisting === null) {
                  _this.setState({
                    isConfirmedExisting: false
                  });
                }
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        })),
        render: function render(_ref3) {
          var closeModal = _ref3.closeModal;
          if (!existingPawn) {
            return;
          }
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].confirmModal
          }, /*#__PURE__*/_react["default"].createElement("p", null, "An existing user was found with the given username:"), /*#__PURE__*/_react["default"].createElement("table", {
            className: "table table-condensed"
          }, /*#__PURE__*/_react["default"].createElement("tbody", null, importantFields.map(function (f) {
            return /*#__PURE__*/_react["default"].createElement("tr", {
              key: f.path
            }, /*#__PURE__*/_react["default"].createElement("td", null, f.label), /*#__PURE__*/_react["default"].createElement("td", null, existingPawn.important[f.path]));
          }))), /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].buttons
          }, /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-secondary",
            type: "button",
            onClick: function onClick() {
              _this.setState({
                isConfirmedExisting: false
              }, function () {
                return closeModal();
              });
            }
          }, "Cancel"), /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-primary",
            type: "button",
            onClick: function onClick() {
              _this.setState({
                isConfirmedExisting: true
              }, function () {
                return closeModal();
              });
            }
          }, "Yes, use existing info")));
        }
      });
    });
    _this.state = {
      existingPawn: null,
      isConfirmedExisting: null
    };
    _this.confirmModal = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  _inherits(RespondentForm, _React$Component);
  return _createClass(RespondentForm, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", null, this.renderConfirmModal(), /*#__PURE__*/_react["default"].createElement(_form["default"], {
        onSubmit: this.onSubmit,
        initialValues: this.props.initialValues,
        forCycle: this.props.forCycle
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(RespondentForm, "propTypes", {
  forCycle: _propTypes["default"].object,
  closeModal: _propTypes["default"].func,
  initialValues: _propTypes["default"].object,
  loadData: _propTypes["default"].func,
  projectId: _propTypes["default"].number
});
_defineProperty(RespondentForm, "defaultProps", {
  loadData: function loadData() {},
  closeModal: function closeModal() {}
});
var mapStateToProps = function mapStateToProps(state) {
  return {
    projectId: state.assignment.admin.currentProjectId
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(RespondentForm);